let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("eufZR"), load("jeGEo"), load("ffEVr"), load("klDll")]).then(() => parcelRequire('D7PHQ'));